import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Screen size configuration

        // Datepicker configuration
        const fecha = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Makes the input read-only
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Transaction ID section (currently empty)
        const transactionId = {
            margin: 5,
            rows: [],
        };

        // Upper section containing datepicker and transaction ID
        const upper_section = {
            cols: [fecha, transactionId],
        };

        // Button configuration
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button for clearing the form
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatically adjusts width
                    click: () => {
                        this.getRoot().clear(); // Clears the form fields
                    },
                },
                {
                    view: 'button', // Button for submitting the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Indicates this button submits the form
                    autowidth: true, // Automatically adjusts width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('depositReportPlayer:filter', [filterdata]); // Calls event with filter data
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Contains upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
